export const CACHE_KEY_LIST_MY_PROPOSAL_REQUEST = 'myProposalRequests';
export const CACHE_KEY_MY_PROPOSAL_REQUEST = 'myProposalRequest-one';
export const ROUTE_USER_PATH_MY_PROPOSAL_REQUEST = '/my-proposal';
export const ROUTE_PATH_MY_PROPOSAL_REQUEST = '/my-proposals';
export const ROUTE_PATH_NEW_PROPOSAL_REQUEST = '/new-proposal';
export const TRANSLATION_PREFIX_MY_PROPOSAL_REQUEST = 'proposalRequest';
export const TRANSLATION_PREFIX_MY_PROPOSAL_REQUEST_OWNER = 'myProposalRequests';
